import { Injectable } from '@angular/core';

import { Permissions } from '@app/entities/enums/permissions/permissions.enum';
import { User } from '@app/entities/models/user/user.model';
import { StorageService, STORAGE_CONSTANTS } from '@app/services/storage';
import { InternalRoute } from '@app/shared/helpers/route.helper';
import { Logger } from '@services/logger/logger.service';
import { NavigationEvent, NavigationEvents, NavigationService } from '@services/navigation/navigation.service';

import { AppManagerService } from '..';
import { AppStatus } from '../app/app.manager.service';
import { NavigationHelperService } from '../navigation/navigation.helper.service';

import { PAGES } from '@/enums/pages.enum';

@Injectable({
  providedIn: 'root'
})
export class OnBoardingGuardService {
  private readonly logger = new Logger('OnBoardingGuardService');

  constructor(
    private navigationService: NavigationService,
    private storage: StorageService,
    private navigationHelperService: NavigationHelperService,
    public appManager: AppManagerService
  ) {}

  async canActivate(): Promise<boolean> {
    const canAccess = await this.checkUserOnBoardingPermission();
    const eventType: NavigationEvents = NavigationEvents.SetRoot;
    const onBoardingRoute: InternalRoute = { path: PAGES.ON_BOARDING };

    if (!canAccess) {
      this.logger.error('User has on boarding permission');

      if (this.appManager.status === AppStatus.INIT) {
        this.navigationHelperService.doRedirect(eventType, onBoardingRoute);
      } else {
        const navEvent = new NavigationEvent(eventType, onBoardingRoute);
        this.navigationService.navigate(navEvent);
      }
    }

    return canAccess;
  }

  private async checkUserOnBoardingPermission(): Promise<boolean> {
    const user: User = await this.storage.get(STORAGE_CONSTANTS.USER);
    const hasOnBoardingPermission = user.permissions.some((permission) => permission === Permissions.ONBOARDING);
    return !hasOnBoardingPermission;
  }
}
